import { SET_VIEWER_CAMPAIGNS } from "./mutation-types";

const mutations = {
  [SET_VIEWER_CAMPAIGNS](state, campaigns) {
    state.campaigns = campaigns;
  },
};

export default mutations;
